<template>
    <div class="menu" v-bind:class="{menu_show:isActive,menu_close:isClose}">
    <el-row class="tac">
        <el-col><!-- :default-openeds="['0']"-->
            <el-menu :default-active='$route.path' :unique-opened='true' :default-openeds="['0']" router class="el-menu-vertical-demo" @select="handleSelect" active-text-color="#fff" text-color="#fff" active-background-color="#fb3846">

                 <el-submenu :index="index + ''" v-for="(item,index) in data2" >
                    <template slot="title"><i :class="item.code" style="vertical-align:middle;"></i>&nbsp;{{item.name}}</template>
                   <!-- children1-->
                    <!--<el-menu-item v-if="item1.children==null" :index="item1.url+''" v-for="(item1,index1) in item.children" v-show="item1.name != '菜单管理'">-->
                    <el-menu-item v-if="item1.children==null" :index="item1.url+''" v-for="(item1,index1) in item.children" >
                        <i :class="item1.code" style="vertical-align:middle;"></i>&nbsp;{{item1.name}}</el-menu-item>

                    <el-submenu :index="index1 + ''" v-if="item1.children!=null" v-for="(item1,index1) in item.children">

                        <template  slot="title"><i :class="item1.code" style="vertical-align:middle;"></i>&nbsp;{{item1.name}}</template>

                       <el-menu-item v-if="item2.children==null"  :index="item2.url+''" v-for="(item2,index2) in item1.children"><i :class="item2.code" style="vertical-align:middle;"></i>&nbsp;{{item2.name}}</el-menu-item>

                        <el-submenu :index="index2 + ''" v-if="item2.children!=null" v-for="(item2,index2) in item1.children">
                            <template slot="title"><i :class="item2.code" style="vertical-align:middle;"></i>&nbsp;{{item2.name}}</template>
                            <el-menu-item :index="item3.url+''" v-for="(item3,index3) in item2.children"><i :class="item3.code" style="vertical-align:middle;"></i>&nbsp;{{item3.name}}</el-menu-item>
                        </el-submenu>
                    </el-submenu>
                </el-submenu>
            </el-menu>
        </el-col>
    </el-row>
    </div>
</template>
<style>

    .tac {
        width: 100%;
        height: 100%;
    }
    /*微菜单css*/
    .el-menu{
        background-color: #333333;
    }

    .menu {
       position:fixed;
        top:40px;
        left:0;
        botom:0;
        padding:20px 0 0 0;
        width:220px;
        min-width:45px;
        max-height:100vh;
        height:calc(100% - 50px);
        z-index:1023;
        overflow-y:scroll;
        overflow-x:hidden;
        background-color:#333333 !important;

    }
    .menu_show{
        animation-duration:.377s;
        animation-name:slideInLeft;
        animation-fill-mode:both;
    }
    .menu_close{
        animation-duration:.377s;
        animation-name:slideOutLeft;
    }

    .el-menu-item.is-active {
        background-color: #fb3846;
    }

    .el-menu-item:hover{
        background-color: #e6323e !important;
    }
    @media screen and (max-width: 799px){
        .menu{
            transform:translate3d(-180px,0,0);

        }
    }
    /*微菜单动画*/
    @keyframes slideOutLeft {
        0%{
            transform: translateZ(0);
        }
        100%{

            transform:translate3d(-100%,0,0)
        }
    }

    @keyframes slideInLeft {
        0%{
            transform:translate3d(-100%,0,0);

        }
        100%{
            transform: translateZ(0);

        }
    }



</style>
<script>
    import blu from 'vue-blu/dist/css/vue-blu.css'

    export default {
        created(){
            //调用查询函
            var params = this.$route.fullPath;
            var pid = params.slice(9,11);
          //  console.log(pid);
            this.resource_id = pid;
           // console.log(this.resource_id);
            this.getData();
        },
        data(){

            return {
                data2: [],
                child: [],
                resource_id: ''
            }
        },
        computed: {
            isActive () {
                return this.$store.state.isActive
            },
            screenbig() {
                return this.$store.state.screenbig
            },

            isClose(){
                return this.$store.state.isClose

            }
        },
        methods: {
            getData(){
                //数据请求
                this.$http.get(this.requetHost + '/sys/user/findPermissions', {
                    params: {
                        "userName": this.getcookie('username'),
                        "pid": this.resource_id
                    }
                }).then(response => {
                        if (response.status === 200) {
                            this.data2 = response.body.tree.slice().sort();
                            console.log(this.data2[0].children );
                            if(this.data2[0].children != undefined){

                                //this.  =response.body.tree[0].children;
                                //缓存Js
                                this.savecookie("child", JSON.stringify(this.data2[0]));
                            }else {
                                this.savecookie("child", JSON.stringify(this.data2[0]));
                            }


                                //this.child = this.data2.children;
                        } else {
                            this.$message({
                                showClose: true,
                                message: '树资源加载不正确',
                                type: 'error'
                            });
                        }
                        this.loading = false;

                    },function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },

//            watch: {
//                // 如果路由有变化，会再次执行该方法
//                '$route': 'getData'
//            },
            handleSelect(val) {
//                console.log(val);
//                sessionStorage.setItem("path",val);
                this.savecookie("menu_url",val,24*60*60);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Sidebar.vue?64513049